import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '$partials/ui';
import { IconClose } from '$partials/icons';

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const RegionItem = ({
    headingCtaLabel,
    headingCtaUrl,
    headingRich,
    onClose,
    title
}) => {
    // methods
    const handleClose = () => {
        onClose();
    };

    // render
    return (
        <div>
            {/* mobile & tablet */}
            <div className='md:hidden layout-container'>
                <div className='layout-grid-negative-gutter'>
                    <div className='py-30'>
                        <div className='layout-grid-col-padding pb-20'>
                            <div className='flex justify-between items-center'>
                                <p className='type-style-4 pb-10'>
                                    Region
                                </p>

                                <Button
                                    className='block rounded-full'
                                    label='Close modal'
                                    look='icon'
                                    onClick={handleClose}
                                    renderIcon={<IconClose />}>
                                </Button>
                            </div>

                            <h3 className='type-style-3'>
                                {title}
                            </h3>
                        </div>

                        <div>
                            {headingRich && (
                                <div
                                    className='type-style-4 layout-grid-col-padding w-10/12 sm-8/12 rich-text'
                                    dangerouslySetInnerHTML={{ __html: headingRich }} />
                            )}

                            {(headingCtaLabel && headingCtaUrl) && (
                                <div className='layout-grid-col-padding'>
                                    <a
                                        className='pill-button mt-40'
                                        href={headingCtaUrl}>
                                        {headingCtaLabel}
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* desktop */}
            <div className='hidden md:block py-30 px-15'>
                <div className='pb-30'>
                    <div className='flex justify-between items-center'>
                        <p className='type-style-4 pb-10'>
                            Region
                        </p>

                        <Button
                            className='block rounded-full'
                            label='Close modal'
                            look='icon'
                            onClick={handleClose}
                            renderIcon={<IconClose />}>
                        </Button>
                    </div>

                    <h3 className='type-style-3'>
                        {title}
                    </h3>
                </div>

                <div>
                    {headingRich && (
                        <div
                            className='rich-text type-style-4 w-10/12'
                            dangerouslySetInnerHTML={{ __html: headingRich }} />
                    )}

                    {(headingCtaLabel && headingCtaUrl) && (
                        <a
                            className='pill-button mt-60'
                            href={headingCtaUrl}>
                            {headingCtaLabel}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    headingCtaLabel: PropTypes.string,
    headingCtaUrl: PropTypes.string,
    headingRich: PropTypes.string,
    onClose: PropTypes.func,
    title: PropTypes.string
};

RegionItem.propTypes = propTypes;

export default RegionItem;
